/**
 * URL builders for the shift endpoints. These are user-token endpoints — the
 * default request interceptor attaches the access token (no `authPaths` entry
 * needed, unlike the device-gated auth calls).
 */
export const ShiftsEndpoints = {
    current: () => '/shifts/current',
    expected: () => '/shifts/expected',
    open: () => '/shifts/open',
    close: () => '/shifts/close',
    closeById: (shiftId: string) =>
        `/shifts/${encodeURIComponent(shiftId)}/close`,
    status: (shiftId: string) =>
        `/shifts/${encodeURIComponent(shiftId)}/status`,
    register: () => '/shifts',
    ledgerSummary: (shiftId: string) =>
        `/shifts/${encodeURIComponent(shiftId)}/ledger-summary`,
};
